// extracted by mini-css-extract-plugin
export var actionText = "_rb-4";
export var container = "_rb-0";
export var leftSection = "_rb-1";
export var rightSection = "_rb-2";
export var settingsButton = "_rb-6";
export var settingsIcon = "_rb-7";
export var shortcut = "_rb-5";
export var shortcutGroup = "_rb-3";